import React from 'react';
import { PrivacyPolicyContent } from './privacyPolicyContent';
import FormattedContent from '../../components/FormattedContent';
import { styled } from '@mui/material';
import Navbar from '../../components/Navbar';
import theme from '../../styles';

const PrivacyPolicy = () => {
  return (
    <MainContainer>
      <Navbar
        position='sticky'
        customtextcolor={theme.color.textPrimary}
        searchBarBackgroundColor={theme.color.beige}
      />
      <LegalContainer>
        <h2>{PrivacyPolicyContent.Title}</h2>
        <FormattedContent content={PrivacyPolicyContent.Content} />
      </LegalContainer>
    </MainContainer>
  );
};

const MainContainer = styled('div')(() => ({}));
const LegalContainer = styled('div')(() => ({
  padding: 50,
  maxWidth: 900,
  margin: '0 auto',
  fontFamily: theme.fontFamily.tertiary,
  color: theme.color.textPrimary,
  lineHeight: 1.6,
}));

export default PrivacyPolicy;
